import { Api } from "./CmsApi";

const api = new Api({ baseUrl: `/api/cms/` });

export default api;
